import { useEffect } from "react";
import { Hero } from "../components/home/Hero";
import { Manifesto } from "../components/home/Manifesto";
import { OnePlusOne } from "../components/home/OnePlusOne";
import { Dimensions } from "../components/home/Dimensions";
import { FTouch } from "../components/home/FTouch";
import { Monoq } from "../components/home/Monoq";
import { Costruzione } from "../components/home/Costruzione";
import { SocialInstagram } from "../components/home/SocialInstagram";
import { Colours } from "../components/home/Colours";
import { PretADrive } from "../components/home/PretADrive";
import { Electric } from "../components/home/Electric";
import { Interior } from "../components/home/Interior";
import { TestDriveSection } from "../components/home/TestDriveSection";
import { NetworkSection } from "../components/home/NetworkSection";
import { FinalCta } from "../components/home/FinalCta";
import { Marquee } from "../components/site/Motion";

const MARQUEE_ITEMS = ["SWAPA™", "The Urban Lifestyle Icon", "100% Electric", "ONE+1™", "Prêt-à-Drive", "Designed in Milan"];

export default function HomePage() {
  useEffect(() => {
    document.title = "SWAPA™ — Microcar elettrica L6e | The Urban Lifestyle Icon";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "SWAPA ZIP è la microcar elettrica L6e progettata per la città: due posti tandem ONE+1, ricarica domestica, design essenziale e preordine online con €200.");
  }, []);

  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee items={MARQUEE_ITEMS} />
      <Manifesto />
      <OnePlusOne />
      <Dimensions />
      <FTouch />
      <Monoq />
      <Costruzione />
      <SocialInstagram />
      <Colours />
      <PretADrive />
      <Electric />
      <Interior />
      <TestDriveSection />
      <NetworkSection />
      <FinalCta />
    </div>
  );
}
